import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=48a6cb8c&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=48a6cb8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6cb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a6cb8c')) {
      api.createRecord('48a6cb8c', component.options)
    } else {
      api.reload('48a6cb8c', component.options)
    }
    module.hot.accept("./goodsList.vue?vue&type=template&id=48a6cb8c&scoped=true", function () {
      api.rerender('48a6cb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationCenter/dialog/goodsList.vue"
export default component.exports